import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OrderTrackingComponent } from './order-tracking.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '', component: OrderTrackingComponent,
        /* canActivate: [NgxPermissionsGuard], data: {
          permissions: {
            only: ['ADMINISTRATION', 'SUPER_ADMIN'],
            redirectTo: userAddRedirectTo
          },
          breadcrumb: 'CourseComponent Component '
        }*/
      },
    ])],
  exports: [RouterModule]
})
export class OrderTrackingRoutingModule { }

/**
 * User redirection if access to user adding screen is not allowed
 */
export function userAddRedirectTo() {
  console.log('Access Denied - insufficient rights for this function');
  // Helper.broadcast('Access Denied - insufficient rights for this function');
  return '/error500';
}
